const registry = new Map<string, any>();

export function registerViewControl(key: string, value: any): void {
  registry.set(key, value);
}

export function getViewBuckets(viewType: string) {
  return registry.get(viewType)?.buckets || [];
}

export function getViewControl(viewType: string) {
  return registry.get(viewType)?.viewControl;
}

export function getViewBucketColor(viewType: string) {
  return registry.get(viewType)?.bucketColor;
}

export function getDefaultSubBuckets(viewType: string, masterData = {}) {
  if (typeof getViewControl(viewType)?.getSubBuckets === 'function') {
    const subBuckets = getViewControl(viewType).getSubBuckets(masterData) || [];
    return subBuckets[0]?.id;
  }
  return null;
}

export const enhanceGeolocationFeatureBuckets = () => {
  return ['All', 'Unplanned', 'Inscan at Hub', 'Inbound'];
};
